/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SlvmonUserPortfolioDto,
} from '../models/index';

export interface GetAverageApyRequest {
    blockChain?: GetAverageApyBlockChainEnum;
    days?: number;
}

export interface GetUserPortfolioQpMaEfsRequest {
    userAddress: string;
    blockChain?: GetUserPortfolioQpMaEfsBlockChainEnum;
}

/**
 * 
 */
export class SLVMONAPIApi extends runtime.BaseAPI {

    /**
     * Get Average APY
     */
    async getAverageApyRaw(requestParameters: GetAverageApyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['blockChain'] = requestParameters['blockChain'];
        }

        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/slvmon/apy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Average APY
     */
    async getAverageApy(requestParameters: GetAverageApyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getAverageApyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get User Portfolio
     */
    async getUserPortfolioQpMaEfsRaw(requestParameters: GetUserPortfolioQpMaEfsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SlvmonUserPortfolioDto>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getUserPortfolioQpMaEfs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['blockChain'] = requestParameters['blockChain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/slvmon/{user_address}/portfolio`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get User Portfolio
     */
    async getUserPortfolioQpMaEfs(requestParameters: GetUserPortfolioQpMaEfsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SlvmonUserPortfolioDto> {
        const response = await this.getUserPortfolioQpMaEfsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetAverageApyBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetUserPortfolioQpMaEfsBlockChainEnum {
    Monad = 'MONAD'
}
